<template>
  <div v-if="Boolean(client)">
    <v-btn v-if="!viewOnly" small text @click="goBack"
      ><v-icon small color="primary">mdi-keyboard-backspace</v-icon> Back
    </v-btn>
    <v-card class="grey lighten-4" flat>
      <v-list-item>
        <v-list-item-avatar>
          <v-icon x-large> mdi-account-circle </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            >{{ client.firstName }} {{ client.lastName }}</v-list-item-title
          >
          <v-list-item-subtitle
            >DOB: {{ client.formattedDob }}</v-list-item-subtitle
          >
          <v-list-item-subtitle>{{
            Boolean(client.osis)
              ? "OSIS: " + client.formattedOsis
              : "NYEIS ID: " + client.nyeisId
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <tabs v-if="!loading" :client="client" :viewOnly="viewOnly"></tabs>
  </div>
</template>
<script>
import Tabs from "./tabs.vue";
export default {
  components: {
    Tabs,
  },
  props: ["clientId", "viewOnly"],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    client() {
      return this.$store.state.clientModule.selectedClient || null;
    },
    isProvider() {
      return this.$store.getters["securityModule/isProvider"];
    },
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("sharedModule/getProviderId", null, {
      root: true,
    });
    if (this.$route.params.clientId || this.clientId) {
      this.$store.commit("uxModule/setShowLoader", true);
      await this.$store.dispatch(
        "clientModule/getClient",
        this.$route.params.clientId || this.clientId
      );
      if (this.isAdmin) {
        await this.$store.dispatch(
          "plansModule/getPlansByClient",
          this.$route.params.clientId || this.clientId
        );
      }
      if (this.isProvider) {
        await this.$store.dispatch(
          "clientModule/getClientChart",
          this.$route.params.clientId || this.clientId
        );
      } else {
        await this.$store.dispatch(
          "clientModule/getClientChartAdmin",
          this.$route.params.clientId || this.clientId
        );
      }
      this.$store.commit("uxModule/setShowLoader", false);
      this.loading = false;
    } else {
      this.$router.push({ name: "ClientLookup" });
    }
  },
  beforeDestroy() {
    this.$store.dispatch("clientModule/clearClient");
  },
  methods: {
    goBack() {
      this.$store.dispatch("clientModule/clearClient");
      this.$router.push({ name: "ClientLookup" });
    },
  },
};
</script>
